export const COLORS = {
  PRIMARY_ORANGE: '#C25D2E',
  WHITE: '#fff',
  TERTIARY_DARK: '#522208',
  BUTTON_GREEN: '#3E5E53',
  GREY_TRANSPARENT: '#25252599',
  LIGHT_GREY: '#ABB3BB',
  SECONDARY_GREEN: '#3a594e',
  MEDIUM_GREY: '#666',
  HEADER_ICON_BACKGORUND: '#CBCBCBbb',
  HEADER_ICON_BORDER_COLOR: '#888',
  LIGHT_BACKGROUND: '#f0f0f0',
  ERROR_RED: '#F44336',
  BORDER_GREY: '#e0e0e0',
};

